const OPEN_MODAL = 'OPEN_MODAL';
export const openModal = (modalId) => ({
  type: OPEN_MODAL,
  payload: modalId,
});
const CLOSE_MODAL = 'CLOSE_MODAL';
export const closeModal = () => ({
  type: CLOSE_MODAL,
});
const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const toggleModal = () => ({
  type: TOGGLE_MODAL,
});

const initialState = {
  modalIsOpen: false,
  modalId: null,
};

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case OPEN_MODAL:
      return { modalIsOpen: true, modalId: payload };
    case CLOSE_MODAL:
      return { modalIsOpen: false, content: null, modalId: null };
    case TOGGLE_MODAL:
      return { ...state, modalIsOpen: !state.modalIsOpen };
    default:
      return state;
  }
};

export const mapStateToProps = (state) => state;
export const mapDispatchToProps = (dispatch) => ({
  openModal: (modalId) => dispatch(openModal(modalId)),
  closeModal: () => dispatch(closeModal()),
  toggleModal: () => dispatch(toggleModal()),
});
